import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type {
  GetZuubInsuranceListRequest,
  GetZuubInsuranceListResponseV3,
} from '../@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from './api';
import { endpoints } from './endpoints';

interface UseGetZuubInsuranceListParams {
  unifiedIds: string[];
  enabled?: boolean;
}

/**
 * Fetches lightweight insurance list data for AutoVerify page (v3 endpoint).
 */
export const useGetZuubInsuranceList = ({
  unifiedIds,
  enabled = true,
}: UseGetZuubInsuranceListParams) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery(
    [endpoints.zuubInsuranceListV3, unifiedIds],
    () => {
      const request: GetZuubInsuranceListRequest = {
        unifiedIds,
      };

      return makeAPIRequestReactQueryWithHeaders<GetZuubInsuranceListResponseV3>(
        endpoints.zuubInsuranceListV3,
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'POST',
        {
          data: request,
        },
      );
    },
    {
      enabled: enabled && unifiedIds.length > 0,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
};
